import { AllStoresStockStatus, StoreStockStatus, WarehouseStockStatus } from '../../../server';

export enum ChipStatus {
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
}

export const mapWarehouseStockStatusToChipStatus = (status?: WarehouseStockStatus): ChipStatus => {
    if (status === WarehouseStockStatus.Available) {
        return ChipStatus.Success;
    }
    return ChipStatus.Error;
};

export const mapAllStoresStockStatusToChipStatus = (status?: AllStoresStockStatus): ChipStatus => {
    if (status === AllStoresStockStatus.Available) {
        return ChipStatus.Success;
    }

    return ChipStatus.Error;
};

export const mapStoreStockStatusToChipStatus = (status?: StoreStockStatus): ChipStatus => {
    if (status === StoreStockStatus.Available || status === StoreStockStatus.AvailableDTS) {
        return ChipStatus.Success;
    }

    if (status === StoreStockStatus.StockLow) {
        return ChipStatus.Warning;
    }

    return ChipStatus.Error;
};
